import styles from "./Tag.module.css";

// Mono uppercase badge. tone: brand | success | warning | danger | neutral
export default function Tag({ tone = "brand", dot = false, children, className = "" }) {
  const toneClass = styles[`tone${tone[0].toUpperCase()}${tone.slice(1)}`];

  return (
    <span className={`${styles.tag} ${toneClass} label-font d-inline-flex align-items-center ${className}`}>
      {dot ? <span className={styles.dot} aria-hidden="true" /> : null}
      {children}
    </span>
  );
}
